export function getScrollbarWidth() {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return 0;
  }

  return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
}

export function lockBodyScroll() {
  const body = document.body;
  const width = getScrollbarWidth();

  body.style.overflow = "hidden";
  body.style.marginRight = "";
  body.style.paddingRight = width ? `${width}px` : "";
  document.documentElement.style.setProperty(
    "--modal-scrollbar-width",
    `${width}px`,
  );

  return width;
}

export function unlockBodyScroll() {
  const body = document.body;
  body.style.overflow = "";
  body.style.marginRight = "";
  body.style.paddingRight = "";
  document.documentElement.style.removeProperty("--modal-scrollbar-width");
}
